export default "__VITE_ASSET__CaviKoLT__"